import { createSlice } from "@reduxjs/toolkit";
import {
  getAllAcademicLevels,
  getAllDeathReasons,
  getAllGovernorates,
  getAllHealthStates,
  getAllHousingOwnerships,
  getAllHousingStates,
  getAllHousingTypes,
  getAllIdentificationTypes,
  getAllIncomeSources,
  getAllMaritalStatus,
  getAllNationality,
  getAllNeighborhood,
  toAddBeneficiary,
  toUpdateBeneficiary,
  toAddFamilyMembers,
  toAddHousingInformations,
  toAddSourceIncomes,
  toAddProofDocuments,
  toRegenerateOtp,
  toVerifyOtp,
  toPrintDeclaration,
  getAllDiseaseType,
  getAllAcademicsYears,
  getAllAcademicsPerformance,
  getAllEducationalInstitutionTypes,
  getAllOrphansBeneficiaryInfo,
  getAllGuardianRelationships,
  getAllDisabilityTypes,
  toUpdateMotherBankInfo,
  toUpdateOrphansInfo,
  toUpdateGuardianInfo,
  toUpdateHousingInfo,
  toUpdateAssistancesInfo,
  toUpdateDocumentsInfo,
  getBeneficiaryDetails,
  getProofDocuments,
  getAllBankAccounts,
  getAllNeighborhoodOnly,
  getDonationAmount,
  getDonationProduct,
  addcontactUsRequest,
  getContactUsList,
  getAllLiabilityType,
} from "../actions/recipient.actions";

/* Intiatlisation of initialeState */
const initialState = {
  TotalContactUs: 0 as number,
  TotalAmounts: 0 as number,
  TotalProducts: 0 as number,
  beneficiary: {} as any,
  orphans: {} as any,
  housing: {} as any,
  incomes: {} as any,
  docs: {} as any,
  ContactRequest: {} as any,
  verifyOtp: {} as any,
  regenrateOtp: {} as any,
  declaration: {} as any,
  motherBankInfo: {} as any,
  orphanInfo: {} as any,
  guardianInfo: {} as any,
  housingInfo: {} as any,
  assistancesInfo: {} as any,
  documentsInfo: {} as any,
  nationality: [] as any,
  governorates: [] as any,
  neighborhoods: [] as any,
  deathReasons: [] as any,
  maritalStatus: [] as any,
  academicLevels: [] as any,
  healthStates: [] as any,
  identificationTypes: [] as any,
  housingTypes: [] as any,
  housingStates: [] as any,
  housingOwnerships: [] as any,
  incomeSources: [] as any,
  liabilityTypes: [] as any,
  diseaseType: [] as any,
  academicYears: [] as any,
  academicsPerformance: [] as any,
  educationalInstitutionTypes: [] as any,
  orphansBeneficiaryInfo: [] as any,
  guardianRelationships: [] as any,
  disabilityTypes: [] as any,
  beneficiaryDetails: [] as any,
  proofDocuments: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  ContactUs: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  bankAccounts: [] as any,
  neighborhoodsOnly: [] as any,
  loading: false as boolean,
  error: null as unknown | null,
  editMode: false as boolean,
  OtpId: parseInt(localStorage.getItem("OtpId") || "-1", 10),
  DonationAmount: [] as any,
  DonationProduct: [] as any,
};

/* recipient slice configuration */
export const recipientSlice = createSlice({
  name: "recipient",
  initialState: initialState,
  reducers: {
    setEditMode: (state, action) => {
      state.editMode = action.payload;
    },
    setOtpId: (state, action) => {
      state.OtpId = action.payload;
      localStorage.setItem("OtpId", action.payload.toString());
    },
  },
  extraReducers: (builder) => {
    /* add beneficiary */
    builder.addCase(toAddBeneficiary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddBeneficiary.fulfilled, (state, action) => {
      state.beneficiary = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddBeneficiary.rejected, (state, action) => {
      state.beneficiary = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* update beneficiary */
    builder.addCase(toUpdateBeneficiary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateBeneficiary.fulfilled, (state, action) => {
      state.beneficiary = action.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateBeneficiary.rejected, (state, action) => {
      state.beneficiary = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* add family members */
    builder.addCase(toAddFamilyMembers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddFamilyMembers.fulfilled, (state, action) => {
      state.orphans = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddFamilyMembers.rejected, (state, action) => {
      state.orphans = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* add housing informations */
    builder.addCase(toAddHousingInformations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddHousingInformations.fulfilled, (state, action) => {
      state.housing = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddHousingInformations.rejected, (state, action) => {
      state.housing = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* add source incomes */
    builder.addCase(toAddSourceIncomes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddSourceIncomes.fulfilled, (state, action) => {
      state.incomes = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddSourceIncomes.rejected, (state, action) => {
      state.incomes = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* add proof documents */
    builder.addCase(toAddProofDocuments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddProofDocuments.fulfilled, (state, action) => {
      state.docs = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddProofDocuments.rejected, (state, action) => {
      state.docs = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* verify otp */
    builder.addCase(toVerifyOtp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toVerifyOtp.fulfilled, (state, action) => {
      state.verifyOtp = action.payload;
      state.loading = false;
    });
    builder.addCase(toVerifyOtp.rejected, (state, action) => {
      state.verifyOtp = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* regenerate otp */
    builder.addCase(toRegenerateOtp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toRegenerateOtp.fulfilled, (state, action) => {
      state.regenrateOtp = action.payload;
      state.loading = false;
    });
    builder.addCase(toRegenerateOtp.rejected, (state, action) => {
      state.regenrateOtp = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* print declaration */
    builder.addCase(toPrintDeclaration.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toPrintDeclaration.fulfilled, (state, action) => {
      state.declaration = action.payload;
      state.loading = false;
    });
    builder.addCase(toPrintDeclaration.rejected, (state, action) => {
      state.declaration = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* get all Nationality */
    builder.addCase(getAllNationality.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNationality.fulfilled, (state, action) => {
      state.nationality = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllNationality.rejected, (state, action) => {
      state.nationality = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all governorates */
    builder.addCase(getAllGovernorates.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllGovernorates.fulfilled, (state, action) => {
      state.governorates = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllGovernorates.rejected, (state, action) => {
      state.governorates = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all neighborhoods */
    builder.addCase(getAllNeighborhood.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNeighborhood.fulfilled, (state, action) => {
      state.neighborhoods = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllNeighborhood.rejected, (state, action) => {
      state.neighborhoods = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all neighborhoods only */
    builder.addCase(getAllNeighborhoodOnly.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNeighborhoodOnly.fulfilled, (state, action) => {
      state.neighborhoodsOnly = action?.payload?.data?.result;
      state.loading = false;
    });
    builder.addCase(getAllNeighborhoodOnly.rejected, (state, action) => {
      state.neighborhoodsOnly = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all death reasons */
    builder.addCase(getAllDeathReasons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDeathReasons.fulfilled, (state, action) => {
      state.deathReasons = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllDeathReasons.rejected, (state, action) => {
      state.deathReasons = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all marital status */
    builder.addCase(getAllMaritalStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllMaritalStatus.fulfilled, (state, action) => {
      state.maritalStatus = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllMaritalStatus.rejected, (state, action) => {
      state.maritalStatus = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all academic levels */
    builder.addCase(getAllAcademicLevels.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAcademicLevels.fulfilled, (state, action) => {
      state.academicLevels = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllAcademicLevels.rejected, (state, action) => {
      state.academicLevels = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all health states  */
    builder.addCase(getAllHealthStates.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHealthStates.fulfilled, (state, action) => {
      state.healthStates = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllHealthStates.rejected, (state, action) => {
      state.healthStates = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all identification types*/
    builder.addCase(getAllIdentificationTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllIdentificationTypes.fulfilled, (state, action) => {
      state.identificationTypes = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllIdentificationTypes.rejected, (state, action) => {
      state.identificationTypes = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all housing types*/
    builder.addCase(getAllHousingTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHousingTypes.fulfilled, (state, action) => {
      state.housingTypes = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllHousingTypes.rejected, (state, action) => {
      state.housingTypes = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all housing states*/
    builder.addCase(getAllHousingStates.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHousingStates.fulfilled, (state, action) => {
      state.housingStates = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllHousingStates.rejected, (state, action) => {
      state.housingStates = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all housing ownership*/
    builder.addCase(getAllHousingOwnerships.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHousingOwnerships.fulfilled, (state, action) => {
      state.housingOwnerships = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllHousingOwnerships.rejected, (state, action) => {
      state.housingOwnerships = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all income sources*/
    builder.addCase(getAllIncomeSources.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllIncomeSources.fulfilled, (state, action) => {
      state.incomeSources = action.payload;
      state.loading = false;
    });
    builder.addCase(getAllIncomeSources.rejected, (state, action) => {
      state.incomeSources = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all disease type*/
    builder.addCase(getAllDiseaseType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDiseaseType.fulfilled, (state, action) => {
      state.diseaseType = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getAllDiseaseType.rejected, (state, action) => {
      state.diseaseType = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get academic years*/
    builder.addCase(getAllAcademicsYears.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAcademicsYears.fulfilled, (state, action) => {
      state.academicYears = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getAllAcademicsYears.rejected, (state, action) => {
      state.academicYears = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get academic performance */
    builder.addCase(getAllAcademicsPerformance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAcademicsPerformance.fulfilled, (state, action) => {
      state.academicsPerformance = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getAllAcademicsPerformance.rejected, (state, action) => {
      state.academicsPerformance = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get educational institution types */
    builder.addCase(getAllEducationalInstitutionTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllEducationalInstitutionTypes.fulfilled,
      (state, action) => {
        state.educationalInstitutionTypes = action.payload.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getAllEducationalInstitutionTypes.rejected,
      (state, action) => {
        state.educationalInstitutionTypes = [];
        state.loading = false;
        state.error = action.payload;
      }
    );
    /* get beneficiary infos */
    builder.addCase(getAllOrphansBeneficiaryInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllOrphansBeneficiaryInfo.fulfilled, (state, action) => {
      state.orphansBeneficiaryInfo = action?.payload?.data;
      state.loading = false;
    });
    builder.addCase(getAllOrphansBeneficiaryInfo.rejected, (state, action) => {
      state.orphansBeneficiaryInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* get guardian relationships */
    builder.addCase(getAllGuardianRelationships.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllGuardianRelationships.fulfilled, (state, action) => {
      state.guardianRelationships = action?.payload?.data;
      state.loading = false;
    });
    builder.addCase(getAllGuardianRelationships.rejected, (state, action) => {
      state.guardianRelationships = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get  disability types */
    builder.addCase(getAllDisabilityTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDisabilityTypes.fulfilled, (state, action) => {
      state.disabilityTypes = action?.payload?.data;
      state.loading = false;
    });
    builder.addCase(getAllDisabilityTypes.rejected, (state, action) => {
      state.disabilityTypes = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* to update mother bank info */
    builder.addCase(toUpdateMotherBankInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateMotherBankInfo.fulfilled, (state, action) => {
      state.motherBankInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateMotherBankInfo.rejected, (state, action) => {
      state.motherBankInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* to update orphans info */
    builder.addCase(toUpdateOrphansInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateOrphansInfo.fulfilled, (state, action) => {
      state.orphanInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateOrphansInfo.rejected, (state, action) => {
      state.orphanInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* to update guardian info */
    builder.addCase(toUpdateGuardianInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateGuardianInfo.fulfilled, (state, action) => {
      state.guardianInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateGuardianInfo.rejected, (state, action) => {
      state.guardianInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* to update housing info */
    builder.addCase(toUpdateHousingInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateHousingInfo.fulfilled, (state, action) => {
      state.housingInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateHousingInfo.rejected, (state, action) => {
      state.housingInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* to update assistances info */
    builder.addCase(toUpdateAssistancesInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateAssistancesInfo.fulfilled, (state, action) => {
      state.assistancesInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateAssistancesInfo.rejected, (state, action) => {
      state.assistancesInfo = {};
      state.loading = false;
      state.error = action.payload;
    });

    /* to update documents info */
    builder.addCase(toUpdateDocumentsInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toUpdateDocumentsInfo.fulfilled, (state, action) => {
      state.documentsInfo = action?.payload;
      state.loading = false;
    });
    builder.addCase(toUpdateDocumentsInfo.rejected, (state, action) => {
      state.documentsInfo = {};
      state.loading = false;
      state.error = action.payload;
    });
    /* get benificiary details */

    builder.addCase(getBeneficiaryDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBeneficiaryDetails.fulfilled, (state, action) => {
      state.beneficiaryDetails = action.payload;
      state.loading = false;
    });
    builder.addCase(getBeneficiaryDetails.rejected, (state, action) => {
      state.beneficiaryDetails = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get proof documents */
    builder.addCase(getProofDocuments.pending, (state) => {
      state.proofDocuments.loading = true;
    });
    builder.addCase(getProofDocuments.fulfilled, (state, action) => {
      state.proofDocuments.data = action.payload;
      state.proofDocuments.loading = false;
    });
    builder.addCase(getProofDocuments.rejected, (state, action) => {
      state.proofDocuments.data = [];
      state.proofDocuments.loading = false;
      state.error = action.payload;
    });
    /* get all bank accounts */
    builder.addCase(getAllBankAccounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllBankAccounts.fulfilled, (state, action) => {
      state.bankAccounts = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getAllBankAccounts.rejected, (state, action) => {
      state.bankAccounts = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get all DonationAmount */
    builder.addCase(getDonationAmount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDonationAmount.fulfilled, (state, action) => {
      state.DonationAmount = action.payload.data;
      state.TotalAmounts = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getDonationAmount.rejected, (state, action) => {
      state.DonationAmount = [];
      state.TotalAmounts = 0;
      state.loading = false;
      state.error = action.payload;
    });
    /* get all DonationProduct */
    builder.addCase(getDonationProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDonationProduct.fulfilled, (state, action) => {
      state.DonationProduct = action.payload.data;
      state.TotalProducts = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getDonationProduct.rejected, (state, action) => {
      state.DonationProduct = [];
      state.TotalProducts = 0;
      state.loading = false;
      state.error = action.payload;
    });

    /* add contact us request  */
    builder.addCase(addcontactUsRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addcontactUsRequest.fulfilled, (state, action) => {
      state.docs = action.payload;
      state.loading = false;
    });
    builder.addCase(addcontactUsRequest.rejected, (state, action) => {
      state.docs = {};
      state.loading = false;
      state.error = action.payload;
    });
    // to get contact us list
    // get all university applications
    builder.addCase(getContactUsList.pending, (state) => {
      state.ContactUs.loading = true;
    });
    builder.addCase(getContactUsList.fulfilled, (state, action) => {
      state.ContactUs.data = action.payload.data;
      state.TotalContactUs = action.payload.total_pages;
      state.ContactUs.loading = false;
    });
    builder.addCase(getContactUsList.rejected, (state, action) => {
      state.ContactUs.data = [];
      state.TotalContactUs = 0;
      state.ContactUs.loading = false;
      state.error = action.payload;
    });
        /* get all income sources*/
    builder.addCase(getAllLiabilityType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllLiabilityType.fulfilled, (state, action) => {
      state.liabilityTypes = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getAllLiabilityType.rejected, (state, action) => {
      state.liabilityTypes = [];
      state.loading = false;
      state.error = action.payload;
    });
  },
});
export const { setEditMode, setOtpId } = recipientSlice.actions;

export default recipientSlice.reducer;
